import { App } from './app';

const app = new App("main");
app.init();
app.startAnimation();
